/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Conversion_Error_Unsupported_LanguageInputs */

const en_conversion_error_unsupported_language = /** @type {(inputs: Conversion_Error_Unsupported_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Documents in ${i?.language} are not supported yet.`)
};

const es_conversion_error_unsupported_language = /** @type {(inputs: Conversion_Error_Unsupported_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Los documentos en ${i?.language} aún no son compatibles.`)
};

/**
* | output |
* | --- |
* | "Documents in {language} are not supported yet." |
*
* @param {Conversion_Error_Unsupported_LanguageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_unsupported_language = /** @type {((inputs: Conversion_Error_Unsupported_LanguageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Unsupported_LanguageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_unsupported_language(inputs)
	return en_conversion_error_unsupported_language(inputs)
});